import React from 'react';
import PropTypes from 'prop-types';
import CompanySearchBox from './CompanySearchBox';
import CompanyResultTable from './CompanyResultTable';
import Loader from '../Loader/Loader';
import DismissSaveButtonsPanel from '../Buttons/DismissSaveButtonsPanel';
import Error from '../../containers/Error';

const Company = (props) => {
    return(
        <div className="col-xs-12">
            <Error />
            <CompanySearchBox
                onSearchInputKeyPressed={props.onSearchInputKeyPressed}
                onSearchInputTextChanged={props.onSearchInputTextChanged}
                onSearchButtonClicked={props.onSearchButtonClicked}
                searchValue={props.company.searchValue}/>
            {props.company.isLoading===true && <Loader /> }
            {props.company.isLoading===false &&
            <CompanyResultTable
                companies= {props.company.companies}
                selectedIndex={props.company.selectedRow? props.company.selectedRow.id : 0}
                onPageChanged={props.onTablePageChange}
                selectedPage= {props.company.tablePage}
                selectedRowChanged = {props.onSelectedTableRowChange} />}
            <DismissSaveButtonsPanel
                isSaveBtnDisabled={!props.company.isRowSelected}
                onDismissButtonClick={props.onDismissButtonClick}
                onSaveButtonClick={props.onSaveButtonClick} />
        </div>
    );
};

Company.propTypes = {
    onSearchInputKeyPressed: PropTypes.func,
    onSearchInputTextChanged: PropTypes.func,
    onSearchButtonClicked: PropTypes.func,
    company: PropTypes.shape({
        searchValue: PropTypes.string,
        companies: PropTypes.array,
        selectedRow: PropTypes.shape({
            id: PropTypes.number
        }),
        isLoading: PropTypes.bool,
        tablePage: PropTypes.number,
        isRowSelected: PropTypes.bool
    }),
    onTablePageChange: PropTypes.func,
    onDismissButtonClick: PropTypes.func,
    onSaveButtonClick: PropTypes.func,
    onSelectedTableRowChange: PropTypes.func,
};

export default Company;


// WEBPACK FOOTER //
// ./src/components/Company/Company.js